import { createFileRoute } from '@tanstack/react-router'
import { accountSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/account/')({
  validateSearch: (search) => accountSearchSchema.parse(search),
  loaderDeps: () => ({}),
})
